/* Quenard — JS de página de producto: variantes, galería, recomendaciones, vistos recientemente */
(function () {
  'use strict';

  var Q = window.Quenard || {};
  var root = document.querySelector('[data-product]');
  if (!root) return;

  var jsonTag = root.querySelector('[data-product-json]');
  var productData = null;
  try {
    productData = jsonTag ? JSON.parse(jsonTag.textContent) : null;
  } catch (err) {
    productData = null;
  }

  /* ------------------------------------------------------------------ */
  /* Galería                                                             */
  /* ------------------------------------------------------------------ */

  var mediaItems = root.querySelectorAll('[data-media-item]');
  var thumbs = root.querySelectorAll('[data-thumb]');

  function showMedia(position) {
    if (!position) return;
    var found = false;
    mediaItems.forEach(function (item) {
      var active = item.getAttribute('data-media-position') === String(position);
      item.classList.toggle('is-active', active);
      if (active) found = true;
    });
    if (!found && mediaItems.length) mediaItems[0].classList.add('is-active');
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-position') === String(position));
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showMedia(thumb.getAttribute('data-media-position'));
    });
  });

  /* Lightbox */
  var lightbox = root.querySelector('[data-lightbox]');
  var zoomBtn = root.querySelector('[data-zoom-open]');
  if (lightbox && zoomBtn) {
    zoomBtn.addEventListener('click', function () {
      var active = root.querySelector('[data-media-item].is-active img');
      if (!active) return;
      var img = lightbox.querySelector('[data-lightbox-image]');
      img.src = active.getAttribute('data-zoom-src') || active.src;
      lightbox.showModal();
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) lightbox.close();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Selector de variantes                                               */
  /* ------------------------------------------------------------------ */

  var picker = root.querySelector('[data-variant-picker]');
  var lowStockThreshold = parseInt(root.getAttribute('data-low-stock-threshold'), 10) || 0;
  // Producto pedible: las variantes agotadas se encargan al proveedor → "Bajo pedido"
  var orderable = root.getAttribute('data-orderable') === 'true';
  var BACKORDER = 'Bajo pedido';

  // Referencias cacheadas una sola vez: estos elementos no se sustituyen al
  // cambiar de variante, así que no hace falta re-consultarlos en cada cambio.
  var els = {
    addButton: root.querySelector('[data-add-button]'),
    addButtonText: root.querySelector('[data-add-button-text]'),
    idInput: root.querySelector('[data-variant-id]'),
    priceCurrent: root.querySelector('[data-price-current]'),
    priceCompare: root.querySelector('[data-price-compare]'),
    saleBadge: root.querySelector('[data-sale-badge]'),
    stockStatus: root.querySelector('[data-stock-status]'),
    priceWrap: root.querySelector('[data-price]'),
    quantityInput: root.querySelector('[data-product-quantity]'),
    qtyScope: root.querySelector('.product__quantity')
  };

  function qtyNotice(text) {
    var n = els.qtyScope && els.qtyScope.querySelector('[data-qty-notice]');
    if (!n) return;
    if (text) { n.textContent = text; n.hidden = false; } else { n.hidden = true; }
  }

  // Ajusta el tope del selector de cantidad al stock de la variante seleccionada
  function syncQtyMax(variant) {
    var qi = els.quantityInput;
    if (!qi) return;
    if (variant && variant.inventory_managed && variant.inventory_policy === 'deny' && variant.inventory_quantity > 0) {
      qi.max = variant.inventory_quantity;
      if ((parseInt(qi.value, 10) || 1) > variant.inventory_quantity) qi.value = variant.inventory_quantity;
    } else {
      qi.removeAttribute('max');
    }
    qtyNotice('');
  }

  function selectedOptions() {
    var values = [];
    root.querySelectorAll('[data-option-position]').forEach(function (fieldset) {
      var checked = fieldset.querySelector('[data-option-input]:checked');
      values.push(checked ? checked.value : null);
    });
    return values;
  }

  function findVariant(options) {
    if (!productData) return null;
    return productData.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === options[i]; });
    });
  }

  function updateUI(variant) {
    if (!variant) {
      if (els.addButton) els.addButton.disabled = true;
      if (els.addButtonText) els.addButtonText.textContent = Q.strings ? Q.strings.unavailable : 'No disponible';
      if (els.stockStatus) {
        els.stockStatus.innerHTML = '<span class="product__stock-dot product__stock-dot--out"></span>' +
          (Q.strings ? Q.strings.unavailable : 'No disponible');
      }
      return;
    }

    if (els.idInput) els.idInput.value = variant.id;

    if (els.priceCurrent && Q.formatMoney) els.priceCurrent.textContent = Q.formatMoney(variant.price);
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (els.priceCompare) {
      els.priceCompare.hidden = !onSale;
      if (onSale && Q.formatMoney) els.priceCompare.textContent = Q.formatMoney(variant.compare_at_price);
    }
    if (els.saleBadge) {
      els.saleBadge.hidden = !onSale;
      if (onSale) {
        var discountPct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        els.saleBadge.textContent = '-' + discountPct + '%';
      }
    }
    if (els.priceWrap) els.priceWrap.classList.toggle('price--on-sale', !!onSale);

    if (els.addButton) els.addButton.disabled = !variant.available;
    if (els.addButtonText) {
      els.addButtonText.textContent = variant.available
        ? (Q.strings ? Q.strings.addToCart : 'Añadir al carrito')
        : (orderable ? BACKORDER : (Q.strings ? Q.strings.soldOut : 'Agotado'));
    }

    if (els.stockStatus) {
      if (!variant.available) {
        els.stockStatus.innerHTML = orderable
          ? '<span class="product__stock-dot product__stock-dot--low"></span>' + BACKORDER
          : '<span class="product__stock-dot product__stock-dot--out"></span>' +
            (Q.strings ? Q.strings.soldOut : 'Agotado');
      } else if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price &&
        variant.inventory_managed &&
        variant.inventory_policy === 'deny' &&
        lowStockThreshold > 0 &&
        variant.inventory_quantity <= lowStockThreshold
      ) {
        els.stockStatus.innerHTML = '<span class="product__stock-dot product__stock-dot--low"></span>¡Últimas unidades disponibles!';
      } else {
        els.stockStatus.innerHTML = '<span class="product__stock-dot"></span>En stock — lista para enviar';
      }
    }

    syncQtyMax(variant);

    if (variant.media_position) showMedia(variant.media_position);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  if (picker && productData) {
    picker.addEventListener('change', function (e) {
      var input = e.target.closest('[data-option-input]');
      if (!input) return;
      var fieldset = input.closest('[data-option-position]');
      var label = fieldset && fieldset.querySelector('[data-selected-value]');
      if (label) label.textContent = input.value;
      updateUI(findVariant(selectedOptions()));
    });
  }

  // Limita la cantidad escrita a mano al stock disponible de la variante
  if (els.quantityInput) {
    els.quantityInput.addEventListener('change', function () {
      var qi = els.quantityInput;
      var max = parseInt(qi.max || '0', 10);
      var val = parseInt(qi.value, 10) || 1;
      if (val < 1) { qi.value = 1; val = 1; }
      if (max > 0 && val > max) {
        qi.value = max;
        qtyNotice('Solo quedan ' + max + (max === 1 ? ' unidad disponible.' : ' unidades disponibles.'));
      } else {
        qtyNotice('');
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Recomendaciones (Section Rendering API)                             */
  /* ------------------------------------------------------------------ */

  var recommendations = document.querySelector('[data-recommendations]');
  if (recommendations && recommendations.getAttribute('data-url')) {
    fetch(recommendations.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          recommendations.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () { /* silencioso */ });
  }

  /* ------------------------------------------------------------------ */
  /* Guardar en "vistos recientemente"                                   */
  /* ------------------------------------------------------------------ */

  if (productData) {
    try {
      var key = 'quenard:recent';
      var priceText = '';
      var priceEl = root.querySelector('[data-price-current]');
      if (priceEl) priceText = priceEl.textContent.trim();

      var list = JSON.parse(localStorage.getItem(key) || '[]');
      list = list.filter(function (item) { return item.handle !== productData.handle; });
      list.unshift({
        handle: productData.handle,
        title: productData.title,
        url: productData.url,
        image: productData.image,
        price: priceText
      });
      localStorage.setItem(key, JSON.stringify(list.slice(0, 8)));
    } catch (err) { /* almacenamiento no disponible */ }
  }
})();
